import { render, staticRenderFns } from "./EndpointMetric.vue?vue&type=template&id=7851018d"
import script from "./EndpointMetric.vue?vue&type=script&lang=js"
export * from "./EndpointMetric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports